import { Formik, FormikProps } from 'formik'
import * as React from 'react'
import * as Yup from 'yup'
import { IGlobalSettingsAssistance } from '../../types/global-settings'
import Loading from '../icons/membership/Loading'
import CheckCircle from '../icons/ui/CheckCircle'
import Close from '../icons/ui/Close'
import Important from '../icons/ui/Important'
import AssistanceForm from './AssistanceForm'
import { IAssistanceCategoryObject, IAssistanceObject } from '../../types'

const validationSchema = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  category: Yup.string().required('Category is required')
})

enum FormState {
  INIT = 'INIT',
  REQUESTING = 'REQUESTING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

interface IAssistanceFormikState {
  formState: FormState
  errorClosed: boolean
  errorMessage: string
}

interface IAssistanceFormikProps {
  title: string
  children: React.ReactNode
  assistance?: IAssistanceObject
  onSubmit?: (label: string) => Promise<void>
  onSuccess?: () => void
  categories: IAssistanceCategoryObject[]
}

export default class MobilityDeviceFormik extends React.Component<IAssistanceFormikProps, IAssistanceFormikState> {
  public formRef: any
  public state: IAssistanceFormikState = {
    formState: FormState.INIT,
    errorClosed: true,
    errorMessage: ''
  }

  public render() {
    return (
      <>
        {!this.state.errorClosed && (
          <div className='pl2 pr2 pt1 pb1 bg-orange flex justify-between align-center'>
            <span className='font-white bold flex align-center'>
              <Important className='icon--small svg-fill-white mr1' />
              <span className='h5 font-white'>{this.state.errorMessage}</span>
            </span>
            <Close className='icon--small svg-fill-white' onClick={this.closeError} />
          </div>
        )}

        <div className='p2'>
          <div className='font-black h4'>{this.props.title}</div>
          <Formik
            ref={r => (this.formRef = r)}
            render={this.formRendrer}
            onSubmit={this.onSubmit}
            validationSchema={validationSchema}
            initialValues={{
              type: this.props.assistance ? this.props.assistance.type : '',
              category: this.props.assistance ? this.props.categories[this.props.assistance.categoryId].id : '',
              instruction: this.props.assistance ? this.props.assistance.instruction : ''
            }}
          />
        </div>
      </>
    )
  }

  private closeError = () => this.setState({ errorClosed: true })

  private formRendrer = (formikProps: FormikProps<IGlobalSettingsAssistance>) => (
    <AssistanceForm categories={this.props.categories} formikProps={formikProps}>
      <div className='right-align'>
        {this.state.formState === FormState.REQUESTING && (
          <>
            <span className='font-black bold h5'>Saving</span>
            <Loading className='col-1 ml1 animation-updating' />
          </>
        )}
        {this.state.formState === FormState.SUCCESS && (
          <>
            <span className='font-black bold h5'>Saved</span>
            <CheckCircle className='svg-stroke-green ml1' />
          </>
        )}
        {![FormState.REQUESTING, FormState.SUCCESS].includes(this.state.formState) && this.props.children}
      </div>
    </AssistanceForm>
  )

  private onSubmit = (values: any) => {
    this.setState({
      formState: FormState.REQUESTING
    })

    if (this.props.onSubmit) {
      this.props
        .onSubmit(values)
        .then(() => this.handleSubmitSuccess())
        .catch(error => this.handleSubmitError(error))
    }
  }

  private handleSubmitError = (error: string) => {
    this.setState({
      formState: FormState.ERROR,
      errorClosed: false,
      errorMessage: error
    })
  }

  private handleSubmitSuccess = () => {
    this.setState({
      formState: FormState.SUCCESS
    })

    if (this.props.onSuccess) {
      this.props.onSuccess()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/AssistanceFormik.tsx